import { Component, OnInit } from '@angular/core';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../services/AccountService';
import { DealService } from '../../services/DealService';
import { AlertService } from '../../services/AlertService';
import { UserService } from '../../services/UserService';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-deal-additional-communication',
  templateUrl: './deal-additional-communication.component.html',
  styleUrls: ['./deal-additional-communication.component.scss']
})
export class DealAdditionalCommunicationComponent implements OnInit {    
    users: any;
    dealId: any;
    searchUserDialogVisible: boolean = false;
    searchUserText: string = '';
    searchUserResultList: any[] = [];
    searchUserDialogMessage: string = '';
    canDeleteDealCommunicationUser: boolean = false;

    constructor(private breadcrumbService: AppBreadcrumbService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private dealService: DealService,
        private alertService: AlertService,
        private userService: UserService,
        private confirmationService: ConfirmationService,) { }

    ngOnInit(): void {
        this.users = this.activatedRoute.snapshot.data['users'];
        this.dealId = this.activatedRoute.snapshot.paramMap.get('id');

        this.breadcrumbService.setItems([
            this.breadcrumbService.deal,
            { label: this.dealId, routerLink: ['deal/' + this.dealId] },
            { label: 'Additional Comunication', routerLink: [] }
        ]);
        this.canDeleteDealCommunicationUser = this.accountService.CanDeleteDealCommunicationUser();
    }

    showSearchBrokerDialog() {
        this.searchUserDialogVisible = true;
        this.searchUserResultList = [];
        this.searchUserText = '';
        this.searchUserDialogMessage = '';
    }

    hideSearchUserDialog() {
        this.searchUserDialogVisible = false;
    }

    searchUser() {
        this.searchUserResultList = [];
        this.searchUserDialogMessage = '';
        if (this.searchUserText != '') {
            this.userService.SearchUsers(this.searchUserText).subscribe(res => {
                if (res.length == 0) {
                    this.searchUserDialogMessage = 'There is no result.';
                } else {
                    this.searchUserResultList = res;
                }
            });
        } else {
            this.searchUserDialogMessage = 'Search keywords is required';
        }
    }

    addUser(user) {
        this.dealService.AddDealAdditionalCommunicationUser(this.dealId, user.Id).subscribe(
            result => {
                if (result.Id != null && result.Id != 0) {
                    var tempUsers = [...this.users];
                    var u = {Id: result.Id, FullName: user.FullName, Email: user.Email };
                    tempUsers.push(u);
                    this.users = tempUsers;
                    this.users.sort((a, b) => (a.Id > b.Id ? 1 : -1));
                    this.hideSearchUserDialog();
                    this.alertService.SetMessage('success', 'Additional communication is added');                                    
                }
                else {
                    this.alertService.SetMessage('error', 'There is an error while adding additional communication');
                }
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while adding additional communication');
            }
        );      
    }

    deleteUser(user) {
        this.confirmationService.confirm({
            message: 'Are you sure you want to remove this user?',
            accept: () => {
                this.dealService.DeleteDealAdditionalCommunicationUser(this.dealId, user.Id).subscribe(
                    result => {
                        if (result) {
                            this.users = this.users.filter(val => val.Id != user.Id);
                            this.hideSearchUserDialog();
                            this.alertService.SetMessage('success', 'Additional communication is removed');
                        }
                        else {
                            this.alertService.SetMessage('error', 'There is an error while removing additional communication');
                        }
                    },
                    error => {
                        this.alertService.SetMessage('error', 'There is an error while removing additional communication');
                    }
                );      
            }
        });              
    }
   

}
